import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-extend",
  "use": "icon-extend-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-extend\"><path d=\"M149.333 512h213.334a21.333 21.333 0 100-42.667H149.333a21.333 21.333 0 100 42.667zm512 0h85.334a21.333 21.333 0 100-42.667h-85.334a21.333 21.333 0 100 42.667zM832 512h85.333a21.333 21.333 0 100-42.667H832A21.333 21.333 0 10832 512zm-320 42.667A85.333 85.333 0 10512 384a85.333 85.333 0 000 170.667zM512 512a42.667 42.667 0 110-85.333A42.667 42.667 0 01512 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol